import React, { useCallback, useMemo } from 'react';

import { getGidFromIdForResource } from '../utils';
import useGlobalModalContext from '../../state/GlobalModalContext';
import BundleCustomize from '../productSwap/BundleCustomize';
import { get } from 'lodash';

export const AddonAddBundleModal = ({
  selectedBundle,
  handleSaveBundle,
  closePanel,
  subscription,
  sellingPlans,
  shopConfiguration,
}: {
  selectedBundle: GlobalProduct & { addonGroupId?: string };
  handleSaveBundle: (
    bundleProps: any,
    _lineId: string,
    selectedItems: any,
    sellingPlan?: string | number,
    discountCodes?: string[],
    oneTimeAddon?: boolean,
    addonGroupId?: string,
  ) => void;
  closePanel: () => void;
  subscription: Subscription;
  sellingPlans: SellingPlan[];
  shopConfiguration: ShopConfiguration;
}): JSX.Element => {
  const addonSellingPolicy =
    selectedBundle?.addonSellingPolicy || 'SUBSCRIPTION';

  const addonDiscounts = get(
    selectedBundle,
    'variants[0].addonsDiscounts',
    {},
  ) as AddonsDiscounts;

  const [isModalOpened, setIsModalOpened] = React.useState(false);
  const product = useMemo(
    () =>
      ({
        VariantId: getGidFromIdForResource(
          `${selectedBundle?.variants[0].id}`,
          'ProductVariant',
        ),
        OneTimeAddon: addonSellingPolicy === 'ONETIME',
        AddonGroupId: selectedBundle?.addonGroupId,
      }) as any as Product,
    [selectedBundle, addonSellingPolicy],
  );

  const { handleModalContent, openGlobalModal, closeGlobalModal } =
    useGlobalModalContext();

  const closeBundleCustomize = useCallback(() => {
    setIsModalOpened(false);
    closeGlobalModal();
    closePanel();
  }, [closeGlobalModal, closePanel]);

  const openModal = useCallback(() => {
    openGlobalModal();
  }, [openGlobalModal]);

  if (selectedBundle) {
    handleModalContent(
      <BundleCustomize
        product={product}
        subscription={subscription}
        shopConfiguration={shopConfiguration}
        bundleProduct={selectedBundle}
        sellingPlans={sellingPlans}
        onConfirm={handleSaveBundle}
        addonDiscount={addonDiscounts}
        onClose={closeBundleCustomize}
      />,
      '',
      closePanel,
    );
  }

  React.useEffect(() => {
    if (selectedBundle && !isModalOpened) {
      closeGlobalModal();
      setIsModalOpened(true);
      openModal();
    }

    if (!selectedBundle && isModalOpened) {
      setIsModalOpened(false);
    }
  }, [
    closeGlobalModal,
    isModalOpened,
    openGlobalModal,
    openModal,
    selectedBundle,
  ]);

  return null;
};
